import messages from '../../../locale/messages';
import { inputDescLimit, inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {

  const errors = {}

  if (!values.fcmPushNotificationKey || values.fcmPushNotificationKey.toString().trim() == "") {
    errors.fcmPushNotificationKey = messages.required;
  } else if (values.fcmPushNotificationKey && values.fcmPushNotificationKey.length > inputDescLimit) {
    errors.fcmPushNotificationKey = messages.inputDescLimitError;
  }

  if (!values.smtpHost || values.smtpHost.toString().trim() == "") {
    errors.smtpHost = messages.required;
  } else if (values.smtpHost && values.smtpHost.length > inputTextLimit) {
    errors.smtpHost = messages.inputTextLimitError;
  }

  if (!values.smtpPort || values.smtpPort.toString().trim() == "") {
    errors.smtpPort = messages.required;
  } else if (values.smtpPort && !values?.isRestrict && (values.smtpPort <= 0 || isNaN(values.smtpPort))) {
    errors.smtpPort = messages.floatError;
  }

  if (!values.smptEmail || values.smptEmail.toString().trim() == "") {
    errors.smptEmail = messages.required && messages.required;
  } else if (values.smptEmail && values.smptEmail.length > inputTextLimit) {
    errors.smptEmail = messages.inputTextLimitError;
  }

  if (!values.smtpSender || values.smtpSender.toString().trim() == "") {
    errors.smtpSender = messages.required;
  } else if (values.smtpSender && values.smtpSender.length > inputTextLimit) {
    errors.smtpSender = messages.inputTextLimitError;
  }

  if (!values.smtpPassWord || values.smtpPassWord.toString().trim() == "") {
    errors.smtpPassWord = messages.required;
  } else if (values.smtpPassWord && values.smtpPassWord.length > inputTextLimit) {
    errors.smtpPassWord = messages.inputTextLimitError;
  }


  if (!values.smtpSenderEmail) {
    errors.smtpSenderEmail = messages.required && messages.required;
  } else if (!values?.isRestrict && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.smtpSenderEmail)) {
    errors.smtpSenderEmail = messages.emailInvalid && messages.emailInvalid;
  }

  if (!values.stripePublishableKey || values.stripePublishableKey.toString().trim() == "") {
    errors.stripePublishableKey = messages.required;
  } else if (values.stripePublishableKey && values.stripePublishableKey.length > inputTextLimit) {
    errors.stripePublishableKey = messages.inputTextLimitError;
  }

  if (!values.maxUploadSize || values.maxUploadSize.toString().trim() == "") {
    errors.maxUploadSize = messages.required;
  } else if (values.maxUploadSize && (values.maxUploadSize <= 0 || isNaN(values.maxUploadSize))) {
    errors.maxUploadSize = messages.invalid;
  }

  if (!values?.fcmApiKey || values?.fcmApiKey?.toString().trim() == "") {
    errors.fcmApiKey = messages.required;
  } else if (values?.fcmApiKey?.length > inputTextLimit) {
    errors.fcmApiKey = messages.inputTextLimitError;
  }

  if (!values?.fcmAuthDomain || values?.fcmAuthDomain?.toString().trim() == "") {
    errors.fcmAuthDomain = messages.required;
  } else if (values.fcmAuthDomain.length > inputTextLimit) {
    errors.fcmAuthDomain = messages.inputTextLimitError;
  }

  if (!values?.fcmProjectId || values?.fcmProjectId.toString().trim() == "") {
    errors.fcmProjectId = messages.required && messages.required;
  } else if (values?.fcmProjectId?.length > inputTextLimit) {
    errors.fcmProjectId = messages.inputTextLimitError;
  }

  if (!values?.fcmStorageBucket || values?.fcmStorageBucket.toString().trim() == "") {
    errors.fcmStorageBucket = messages.required;
  } else if (values?.fcmStorageBucket?.length > inputTextLimit) {
    errors.fcmStorageBucket = messages.inputTextLimitError;
  }

  if (!values?.fcmMessagingSenderId || values?.fcmMessagingSenderId?.toString().trim() == "") {
    errors.fcmMessagingSenderId = messages.required;
  } else if (values?.fcmMessagingSenderId?.length > inputTextLimit) {
    errors.fcmMessagingSenderId = messages.inputTextLimitError;
  }

  if (!values?.fcmAppId || values?.fcmAppId?.toString().trim() == "") {
    errors.fcmAppId = messages.required;
  } else if (values?.fcmAppId?.length > inputTextLimit) {
    errors.fcmAppId = messages.inputTextLimitError;
  }

  if (!values?.fcmMeasurementId || values?.fcmMeasurementId?.toString().trim() == "") {
    errors.fcmMeasurementId = messages.required;
  } else if (values?.fcmMeasurementId?.length > inputTextLimit) {
    errors.fcmMeasurementId = messages.inputTextLimitError;
  }

  if (!values?.fcmVapidKey || values?.fcmVapidKey.toString().trim() == "") {
    errors.fcmVapidKey = messages.required;
  } else if (values?.fcmVapidKey?.length > inputTextLimit) {
    errors.fcmVapidKey = messages.inputTextLimitError;
  }
  if (!values.stripeSecretKey || values.stripeSecretKey.toString().trim() == "") {
    errors.stripeSecretKey = messages.required;
  } else if (values.stripeSecretKey && values.stripeSecretKey.length > inputTextLimit) {
    errors.stripeSecretKey = messages.inputTextLimitError;
  }

  if (!values.payPalClientId || values.payPalClientId.toString().trim() == "") {
    errors.payPalClientId = messages.required;
  } else if (values.payPalClientId && values.payPalClientId.length > inputTextLimit) {
    errors.payPalClientId = messages.inputTextLimitError;
  }
  if (!values.payPalSecret || values.payPalSecret.toString().trim() == "") {
    errors.payPalSecret = messages.required;
  } else if (values.payPalSecret && values.payPalSecret.length > inputTextLimit) {
    errors.payPalSecret = messages.inputTextLimitError;
  }
  if (!values?.googleMapBrowserApiKey || values?.googleMapBrowserApiKey.toString().trim() == "") {
    errors.googleMapBrowserApiKey = messages.required;
  } else if (values?.googleMapBrowserApiKey?.length > inputTextLimit) {
    errors.googleMapBrowserApiKey = messages.inputTextLimitError;
  }
  if (!values.googleMapServerApiKey || values.googleMapServerApiKey.toString().trim() == "") {
    errors.googleMapServerApiKey = messages.required;
  } else if (values.googleMapServerApiKey && values.googleMapServerApiKey.length > inputTextLimit) {
    errors.googleMapServerApiKey = messages.inputTextLimitError;
  }

  return errors;
}


export default validate;
